{
  "post-office.cc-changeboarding-block-menu-primary-new.spotlight-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary-new.spotlight-description": [
    {
      "type": 0,
      "value": "Blocks of content can now be easily transformed, kept in sync, and saved as a template!"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary-new.spotlight-header": [
    {
      "type": 0,
      "value": "Transform, sync & save blocks"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary-new.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Blocks feature illustration"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary.spotlight-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary.spotlight-description": [
    {
      "type": 0,
      "value": "Blocks of content can now be easily transformed, kept in sync, and saved as a template!"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary.spotlight-header": [
    {
      "type": 0,
      "value": "Transform, sync & save blocks"
    }
  ],
  "post-office.cc-changeboarding-block-menu-primary.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Blocks feature illustration"
    }
  ],
  "post-office.cc-changeboarding-block-menu-templates.spotlight-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.cc-changeboarding-block-menu-templates.spotlight-description": [
    {
      "type": 0,
      "value": "Save any content as a block template for easy reuse across Confluence and Jira!"
    }
  ],
  "post-office.cc-changeboarding-block-menu-templates.spotlight-header": [
    {
      "type": 0,
      "value": "Save content with block templates"
    }
  ],
  "post-office.cc-changeboarding-block-menu-templates.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Block templates feature illustration"
    }
  ],
  "post-office.cc-changeboarding-block-menu-templates.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-description": [
    {
      "type": 0,
      "value": "Easily change content blocks from one format to another!"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-header-new": [
    {
      "type": 0,
      "value": "Quickly change format"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-image-alt-new": [
    {
      "type": 0,
      "value": "Format feature illustration"
    }
  ],
  "post-office.cc-changeboarding-block-menu-transform.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.activation-spotlight-description": [
    {
      "type": 0,
      "value": "You can reuse content in synced blocks in Confluence and Jira. Just copy and paste this synced block in a new location"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.activation-spotlight-header": [
    {
      "type": 0,
      "value": "Reuse this content"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.activation-spotlight-image-alt": [
    {
      "type": 0,
      "value": "Animation showing a synced block being copied from its source and pasted into another page as a linked reference"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.spotlight-button": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.spotlight-description": [
    {
      "type": 0,
      "value": "Synced blocks maintain source of truth across Confluence & Jira. Insert, copy, and paste!"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.spotlight-header": [
    {
      "type": 0,
      "value": "Keep content in sync"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Synced blocks feature illustration"
    }
  ],
  "post-office.cc-changeboarding-synced-blocks.spotlight-learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "post-office.cc-editor-table-cell-menu-changes.spotlight-button": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "post-office.cc-editor-table-cell-menu-changes.spotlight-description": [
    {
      "type": 0,
      "value": "Controls to add or delete rows and columns have moved to their own menus. You can also align content vertically from the cell menu."
    }
  ],
  "post-office.cc-editor-table-cell-menu-changes.spotlight-header": [
    {
      "type": 0,
      "value": "Simple table controls"
    }
  ],
  "post-office.cc-editor-table-cell-menu-changes.spotlight-image-alt": [
    {
      "type": 0,
      "value": "Table cell menu illustration"
    }
  ]
}